import OperatorStationPage from "../components/OperatorStationPage";

export default function IstasyonSiraPage() {
  return (
    <OperatorStationPage
      config={{
        role: "Sıra Operatörü",
        title: "Sıra Operatörü",
        subtitle: "Sadece sıra bekleyen hayvanları başlatır. Mevcut kesim ekranı ve TV akışı bozulmaz.",
        status: "queued",
        actionLabel: "Kesime Girdi",
        actionVariant: "primary",
        nextStatus: "entered",
        allowDirectDone: false,
        allowPackingZone: false,
      }}
    />
  );
}
